import React, { useState, useEffect } from 'react'
import SelectCompanyContext from '../../../account/components/selectCompany/selectCompanyContext'
import { useAuth } from '../../../auth/useAuth'

const CompanySwitchRenderer = (props) => {
  const { user, company } = props
  const { getIdentity } = useAuth()
  const [loading, setLoading] = useState(false)
  const [companyList, setCompanyList] = useState([])
  const [currentCompany, setCurrentCompany] = useState(null)
  const [selectedCompany, setSelectedCompany] = useState()

  const onSwitchCompany = (company) => {
    setSelectedCompany(company)
  }

  const onFailGetCompany = (response) => {
    setLoading(false)
  }

  const onSuccessGetCompany = (response) => {
    setLoading(false)
    props.cognitoLoginUser(response)
  }

  const mapCompany = (company) => ({ value: company.id, label: company.name })

  const save = () => {
    setLoading(true)
    getIdentity({ user, selectedCompanyId: selectedCompany.value, success: onSuccessGetCompany, fail: onFailGetCompany })
  }

  useEffect(() => {
    let subscribed = true
    if (subscribed) {
      setLoading(true)
      const mapCompanies = () => (user ? user.companies.map((company) => mapCompany(company)) : [])
      setCompanyList(mapCompanies)
      const currentCompany = user && user.isAdmin ? company : user.companies.find((userCompany) => userCompany.id === company._id)
      setCurrentCompany(mapCompany(currentCompany))
      setSelectedCompany(mapCompany(currentCompany))
      setLoading(false)
    }
    return () => (subscribed = false)
  }, [])

  return (
    <SelectCompanyContext {...{ companyList, selectedCompany, currentCompany, setSelectedCompany: onSwitchCompany, getCompany: save, loading, user }} />
  )
}

export default CompanySwitchRenderer
